export enum PopupType {
  Restart = 'Restart',
  Reset = 'Reset',
  Rollback = 'Rollback',
  StateSync = 'StateSync',
}
